import React, { useState, useEffect, useRef, useContext } from "react";
import {
  ContentWrapper,
  SnackbarContent,
  PageTitle,
  SVGContainer,
  TTBody
} from "../../styled-components/shared";
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import { Switch, Button } from "@zebra-fed/zds-react-desktop";
import Snackbar from "@material-ui/core/Snackbar";
import styled from "styled-components";
import firebaseUtil from "../../data/FirebaseUtil";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import DropdownCustom from '../../components/DropdownCustom';

import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { withStyles } from '@material-ui/core/styles';

import { AuthContext } from "../../authentication/Auth";
import app from "../../authentication/firebaseStart";
import BottomNavLinks from "../../components/BottomNavLinks";

import { DataContext } from '../../data/DataContext';
import config from "../../data/application.properties";
const firestore = app.firestore();

const SectionTitle = styled.h4`
    display: flex;
    font-size: 20px;
    font-weight: bold;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  padding: 10px;
`;

const ButtonContainer = styled.div`
    display: inline;
    max-width: 500px;
    justify-content: initial;
`;

const StyledTextField = styled(TextField)`
  margin-left: 2px !important;
  margin-bottom: 20px !important;
`;


const ErrorMsg = styled.p`
    margin: 0;
    padding-left: 10px;
    font-size: 0.75rem;
    margin-top: 3 px;
    text-align: left;
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 400;
    line-height: 1.66;
    letter-spacing: 0.03333em;
    color: red;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 400px;
  margin-bottom: 0px;
  & > *:first-child {
    flex: 1;
  }
`;

const SubHeader = styled.h2`
  font-size: 16px;
  color: #4c4c4c;
  margin: 0;
  line-height: 19px;
  font-weight: 600;
`;

const StyledOnDiv = styled.div`
  margin-left: 65px;
`;

const QuestionTT = withStyles((theme) => ({
  position: 'absolute',
    bottom: '3px',
    right: '-15px',
  tooltip: {
    backgroundColor: 'rgb(0, 122, 186)',
    color: theme.typography.pxToRem(12),
    maxWidth: 300,
    border: '1px solid rgb(0, 122, 186)',
  },

  arrow: {
    color: 'rgb(0, 122, 186)'
  },
}))(Tooltip);

const CheckboxComp = styled.label`
    display: flex;
    align-items: center;
    margin-left: -10px;
`;


export default function BTSettingsPage() {
  const context = useContext(AuthContext);
  const companyID = context.currentUser.claims.companyID;
  const userId = context.currentUser.uid;
  let {globalAppSettings, setGlobalAppSettings} = useContext(DataContext);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation()
  const [enableSwitch, setEnableSwitch] = useState(false);

  const [anyOneChanged, setAnyOneChanged] = useState(false);
  const [isPageLoading, setPageLoading] = useState(false);
  
  const [enableAudio, setEnableAudio] = useState(true);
  const [virtualTethering, setVirtualTethering] = useState(true);

  const [whenDisconnected, setWhenDisconnected] = useState(true);
  const [whenUnpaired, setWhenUnpaired] = useState(true);
  const [whenUltraLowPower, setWhenUltraLowPower] = useState(true);
  
  const [enableBTScannerTracking, setEnableBTScannerTracking] = useState(false);
  const [enableVibrate, setEnableVibrate] = useState(true);
  const [enableLED, setEnableLED] = useState(true);
  const [enablePagingLED, setPagingEnableLED] = useState(true);
  const [enablePagingBeep, setPagingEnableBeep] = useState(true);
  const [notificationMessage, setNotificationMessage] = useState(t('btScannersNotifications.defaultNotificationMsg'));
  const [testAud, setTestAud] = useState("Default");
  const [customAudioToneText, setCustomAudioToneText] = useState("");
  const [vibratePattern, setVibratePattern] = useState([{
    label: t('btScannersNotifications.systemDefault'), 
    value: t('btScannersNotifications.systemDefault')
  }]);
  const [vibratePatternArr, setVibratePatternArr] = useState([
    { label: t('btScannersNotifications.systemDefault'), value: t('btScannersNotifications.systemDefault') },
    { label: t('btScannersNotifications.Short'), value: t('btScannersNotifications.Short') },
    { label: t('btScannersNotifications.Medium'), value: t('btScannersNotifications.Medium') },
    { label: t('btScannersNotifications.Long'), value: t('btScannersNotifications.Long') }
  ]);
  const serverResponse = useRef("");
  const [audioCustom, setaudioCustom] = useState(false)
 
  const errors = useRef([]);
  

  const onClickCancelBtn = () => {
    setAnyOneChanged(false);
    getSettings();
  }

  useEffect(() => {
    if (Object.keys(globalAppSettings)?.length > 0 ) {
      getSettings();
    }
  }, [globalAppSettings]);

  async function getSettings() {
    let data = globalAppSettings;
    console.log("Got data *********",data);
    if (data) {
      console.log("Got data",data);
      setEnableBTScannerTracking(data?.enableBTScannerTracking);
      let btTrackerSettings = {
        scannerBeaconConditions:{
          onDisconnect:true,
          onUnpair:true,
          onLowPower:true,
        },
        paging:{
          enableLED:true,
          enableBeep:true
        },
        deviceNotification:{
          enableAudio: true,
          enableLED:true , 
          enableVibrate:true          
        },
        virtualTethering:true
        
      }
      
      if(data?.btTrackerSettings?.deviceNotification?.enableAudio === false){
        btTrackerSettings.deviceNotification.enableAudio = false;
      }
      if(data?.btTrackerSettings?.virtualTethering === false){
        btTrackerSettings.virtualTethering = false;
      }

        
      setEnableAudio(btTrackerSettings.deviceNotification.enableAudio);
      setVirtualTethering(btTrackerSettings.virtualTethering);
      
      
      if(data?.btTrackerSettings?.scannerBeaconConditions?.onDisconnect === false){
        btTrackerSettings.scannerBeaconConditions.onDisconnect = false
      }
      if(data?.btTrackerSettings?.scannerBeaconConditions?.onLowPower === false){
        btTrackerSettings.scannerBeaconConditions.onLowPower = false
      }
      if(data?.btTrackerSettings?.scannerBeaconConditions?.onUnpair === false){
        btTrackerSettings.scannerBeaconConditions.onUnpair = false
      }



      setWhenDisconnected(btTrackerSettings.scannerBeaconConditions.onDisconnect)
      setWhenUnpaired(btTrackerSettings.scannerBeaconConditions.onUnpair);
      setWhenUltraLowPower(btTrackerSettings.scannerBeaconConditions.onLowPower);

      
      setCustomAudioToneText(data?.btTrackerSettings?.deviceNotification?.audioName)
      setaudioCustom(data?.btTrackerSettings?.deviceNotification?.audioName !== "Default")
      //console.log(audioCustom,'audioCustom')

      if(data?.btTrackerSettings?.deviceNotification?.enableVibrate === false){
        btTrackerSettings.deviceNotification.enableVibrate = false
      }
      setEnableVibrate(btTrackerSettings.deviceNotification.enableVibrate);

      //console.log(data?.lostDeviceNotificationSettings?.audioName,'Check if undefined')
      if (data?.btTrackerSettings?.deviceNotification?.audioName === "Default") {
        //console.log(data?.lostDeviceNotificationSettings?.audioName,'Inside data?.lostDeviceNotificationSettings?.audioName If')
        setTestAud(data.btTrackerSettings?.deviceNotification?.audioName);
        setCustomAudioToneText("");
      }
      else {
        if(!data?.btTrackerSettings?.deviceNotification?.audioName) {
          console.log('undefined audio name')
          setTestAud("Default");
          setaudioCustom(false);
          console.log(testAud,'testAud if undefined')
        }
        else {
          //console.log(data.lostDeviceNotificationSettings?.audioName,'data.lostDeviceNotificationSettings?.audioName')
          setTestAud(data.btTrackerSettings?.deviceNotification?.audioName);
          setCustomAudioToneText(data.btTrackerSettings?.deviceNotification?.audioName)
        }
        
      }
      //console.log(data.lostDeviceNotificationSettings.vibratePattern,'data.lostDeviceNotificationSettings.vibratePattern')
      let vibratePat = data?.btTrackerSettings?.deviceNotification?.vibratePattern;
      console.log(vibratePat, 'vibratePatvibratePatvibratePat')
      if (vibratePat === "Default") {
        setVibratePattern([
          {
            label: t('btScannersNotifications.systemDefault'),
            value: t('btScannersNotifications.systemDefault')
          }
        ]);
      }
      else {
        if(vibratePat === undefined) {
          console.log(vibratePat,'if vibratePat undefined')
          setVibratePattern([
            {
              label: t('btScannersNotifications.systemDefault'), value: t('btScannersNotifications.systemDefault')
            }
          ]);  
        }
        else {
          setVibratePattern([
            {
              label: vibratePat,
              value: vibratePat
            }
          ]);
        }
      }
      
      if(data.btTrackerSettings?.deviceNotification?.enableLED === false){
        btTrackerSettings.deviceNotification.enableLED = false
      }
      
      if(data.btTrackerSettings?.paging?.enableBeep === false){
        btTrackerSettings.paging.enableBeep = false
      }

      if(data.btTrackerSettings?.paging?.enableLED === false){
        btTrackerSettings.paging.enableLED = false
      }
        

      setEnableLED(btTrackerSettings.deviceNotification.enableLED)
      setNotificationMessage(data.btTrackerSettings?.deviceNotification?.notificationMessage);
      
      setPagingEnableBeep(btTrackerSettings.paging.enableBeep);
      setPagingEnableLED(btTrackerSettings.paging.enableLED);
    
    }
  }

  async function handleSaveChanges() {
    errors.current = [];
    console.log(whenDisconnected, 'whenDisconnected');
    let vibratePatternStr = vibratePattern[0]?.value;
    if (vibratePatternStr === "System Default") {
      vibratePatternStr = "Default";
    }
    //console.log(vibratePatternStr, 'vibratePatternStr')
    // let ledColorStr = ledColor[0].value;
    let data = {
      enableBTScannerTracking: enableBTScannerTracking ,
      btTrackerSettings: {
        deviceNotification: {
          audioName: customAudioToneText,
          enableAudio: enableAudio,
          enableLED: enableLED,
          enableVibrate: enableVibrate,
          notificationMessage: notificationMessage,
          vibratePattern: vibratePatternStr
        },
        paging : {
          enableBeep: enablePagingBeep,
          enableLED: enablePagingLED
        },
        scannerBeaconConditions : {
          onDisconnect: whenDisconnected,
          onLowPower: whenUltraLowPower,
          onUnpair: whenUnpaired
        },
        virtualTethering: virtualTethering
      }
     
    };
    console.log("Saving",data);
    
    if (errors.current.length === 0) {
      setIsLoading(true);
      let response = await firebaseUtil.saveAppSettings(data);
            setIsLoading(false);
      serverResponse.current = response;
      if (response.status) {
        setGlobalAppSettings({...globalAppSettings,enableBTScannerTracking:enableBTScannerTracking,
        btTrackerSettings:data.btTrackerSettings});
        if(enableBTScannerTracking){
          updateUserPreferenceData()
        }
        setAnyOneChanged(false);
      }
      setSnackbarOpen(true);
    }

  }

  const updateUserPreferenceData= async() => {
    try {
      //getting latest value
      let columnData = await firestore
        .collection("tenants")
        .doc(config.TENANT_ID)
        .collection("Users")
        .doc(userId)
        .collection("Preferences")
        .get();
  
      const data = {};
      if (typeof columnData != typeof undefined) {
        columnData.forEach((col) => {
          data[col.id] = col.data();
        });
      }
      if (data?.DeviceDash?.columnOrder) {
        const columnData = data.DeviceDash.columnOrder
       
        console.log("columnData ==== ",columnData)
        let {DeviceDash}= JSON.parse(sessionStorage.getItem("dashboardColumn"));
        let accesoryIndex = DeviceDash.indexOf('accessory')
    
        if(enableBTScannerTracking === false){
          columnData.splice(accesoryIndex,1)
        }else if(accesoryIndex == -1){
          //add only if its not present
          columnData.splice(4, 0, "accessory");
        }
        sessionStorage.setItem(
          "dashboardColumn",
          JSON.stringify({"DeviceDash":columnData})
        );
        savePreferenceInDb(columnData)
      } 
    } catch (err) {
      console.log("updateUserPreferenceData err ==",err);
    }
  }

  const savePreferenceInDb = async (orderedItemsArray) => {
    try {
        await firestore
            .collection("tenants")
            .doc(companyID)
            .collection("Users")
            .doc(userId)
            .collection("Preferences")
            .doc("DeviceDash")
            .set({
              columnOrder: orderedItemsArray,
            }, { merge: true });
    } catch (err) {
      console.log("Error..........")
      console.log(err);
    }
  };

  const onAudioCheckbox = (audioEvent) => {
    setAnyOneChanged(true);
    setEnableAudio(audioEvent);
  }

  const onVirtualTethering = (itemEvent) => {
    setAnyOneChanged(true);
    setVirtualTethering(itemEvent);
  }  

  const onWhenDisconnected = (itemEvent) => {
    setAnyOneChanged(true);
    setWhenDisconnected(itemEvent);
  } 
  const onWhenUnpaired = (itemEvent) => {
    setAnyOneChanged(true);
    setWhenUnpaired(itemEvent);
  } 
  const onWhenUltraLowPower = (itemEvent) => {
    setAnyOneChanged(true);
    setWhenUltraLowPower(itemEvent);
  }       
  
  const onAudioTone = (audioToneEvent) => {
    if (audioToneEvent === "Default") {
      setTestAud(audioToneEvent);
      setCustomAudioToneText("");
    }
    else {
      setTestAud(audioToneEvent);
      setCustomAudioToneText(audioToneEvent);
    }
    setAnyOneChanged(true);
  }

  const onCustomAudioToneText = (customToneVal) => {
    setCustomAudioToneText(customToneVal);
    setTestAud(customToneVal);
    setAnyOneChanged(true);
  }

  const onVibrateCheckbox = (vibrateEvent) => {
    setEnableVibrate(vibrateEvent);
    setAnyOneChanged(true);
  }

  const onLedCheckbox = (ledEvent) => {
    setEnableLED(ledEvent);
    setAnyOneChanged(true);
  }

  const onPagingLedCheckbox = (event) => {
    setPagingEnableLED(event);
    setAnyOneChanged(true);
  }

  const onPagingBeepCheckbox = (event) => {
    setPagingEnableBeep(event);
    setAnyOneChanged(true);
  }

  const onClickResetBtn = () => {
    setAnyOneChanged(true);
    setEnableBTScannerTracking(false);
    setEnableAudio(true);
    setVirtualTethering(true);
    setWhenDisconnected(true);
    setWhenUnpaired(true);
    setWhenUltraLowPower(true);
    setEnableVibrate(true);
    setEnableLED(true);
    
    setPagingEnableLED(true);
    setPagingEnableBeep(true);
    
    setNotificationMessage(t('btScannersNotifications.defaultNotificationMsg'));
    setTestAud("Default");
    setCustomAudioToneText('');
    setVibratePattern([{ label: t('btScannersNotifications.systemDefault'), value: t('btScannersNotifications.systemDefault') }]);

  }

  const onChangeSwitch = (switchEvent) => {
    if (switchEvent === true) {
      setEnableSwitch(true);
    }
    else {
      setEnableSwitch(false);
    }
    setEnableBTScannerTracking(switchEvent);
    if (switchEvent !== enableBTScannerTracking) {
      setAnyOneChanged(true);
    }
  }

  const onVibratePatternChange = (vibratePatternVal) => {
    setVibratePattern([
      { label: vibratePatternVal, value: vibratePatternVal }
    ]);
    setAnyOneChanged(true);
  }

  /*   const onLedColorChange = (ledColor) => {
      console.log(ledColor, 'led Color value')
      setLedColor([
        { label: ledColor, value: ledColor }
      ]);
      setAnyOneChanged(true);
    } */

  const onPopupMsgChange = (popupMsg) => {
    //console.log(popupMsg, 'sdsds')
    //console.log(popupMsg.length)
    if (popupMsg.length > 65) {
      return;
    }
    // else if(popupMsg.length < 5) {
    //   return;
    // }
    else {
      setNotificationMessage(popupMsg);
      setAnyOneChanged(true);
    }
  }


  //console.log(vibratePattern, 'vibratePattern')
  return (
    <>
    <StyledContentWrapper
        style={{ cursor: isLoading ? "wait" : "default", opacity: isLoading ? '0.4' : '1' }}>
        <PageTitle>{t('btScannerConfiguration')}</PageTitle>

        <div
            style={{
                display: isLoading ? "flex" : "none",
                justifyContent: "left",
            }}
        >
            <CircularProgress />
        </div>
        <div style={{ display: isLoading ? "none" : "block" }}>
          <SectionTitle>{t('btScanners.tracking')}</SectionTitle>   
            <FormGroup style={{ marginLeft: '20px' }}>
              <FlexRow style={{display:"flex"}}>
                <SubHeader>{t('btScanners.track')}</SubHeader>
                <FormControl component="fieldset" style={{ paddingLeft: 0 }}>
                  <FormControlLabel
                  classes="onOffSwitch"
                  control={<Switch color="primary" checked={enableBTScannerTracking} 
                  onChange={(e) => onChangeSwitch(e)} />}
                  style={{ marginLeft: 0, fontWeight: 'bold', marginTop: '30px' }}/>
                <br></br>
                </FormControl>
              
              </FlexRow>
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={virtualTethering}
                    onChange={(e) => onVirtualTethering(e.target.checked)}
                    name="virtualTethering"
                  />
                }
                label={t('btScanners.tethering')}
                
              />
            </FormGroup>

            <SectionTitle>{t('btScanners.deviceNotifications')} </SectionTitle> 
        
            <FormGroup style={{ marginLeft: '20px', width: '300px' }}>
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={enableAudio}
                    onChange={(e) => onAudioCheckbox(e.target.checked)}
                    name="audio"

                    // value={setEnableAudio}
                  />
                }
                label={t('btScannersNotifications.Audio')}
                
              />
              <FormControl component="fieldset" style={{ marginLeft: '30px',position:"relative" }}
              >
                <RadioGroup  aria-label="audio_tone" name="audio_tone" value={testAud}
                  onChange={(e) => {
                    onAudioTone(e.target.value);
                    setaudioCustom(!audioCustom);
                  }
                  }>
                  <FormControlLabel value="Default"
                    control={
                      <Radio color="primary" 
                      disabled={!enableAudio || !enableBTScannerTracking }/>
                    } label={t('btScannersNotifications.systemDefault')}
                  />
                  <FormControlLabel value={customAudioToneText}
                    control={

                      <Radio onchange={(e)=>{ }} color="primary" 
                      disabled={ !enableAudio || !enableBTScannerTracking }/>
                    } label={
                      //!enableAudio ||

                      
                      <TextField id="custom_tone_name" disabled={  
                        !enableBTScannerTracking || !enableAudio || !audioCustom } name="custom_tone_name" style={{ width: '150px' }}
                        label={t('btScannersNotifications.customToneName')} onChange={(e) => { onCustomAudioToneText(e.target.value); }}
                        value={customAudioToneText} />

                        
                    } /> 
                </RadioGroup>
                <div style={    {position: 'absolute',    bottom: '3px',    right: '-15px'}}>
          <QuestionTT  arrow title={<>
                  <TTBody>

                    {t('btScannersNotifications.customtonetooltip')}

                  </TTBody>
                </>}>
                  <SVGContainer>
                    <HelpOutlineIcon />
                  </SVGContainer>
                </QuestionTT>
        </div>
              
                {errors.current.includes("audioToneNameErr") ? (<ErrorMsg>{t('validation.rules.lostDevice.audioToneNameErr')}</ErrorMsg>) : null}

              </FormControl>

              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    onChange={(e) => onVibrateCheckbox(e.target.checked)}
                    name="vibrate"
                    // color="primary"
                    checked={enableVibrate}
                  />
                }
                label={t('btScannersNotifications.Vibrate')}
                
              />
              <div className="lost-device-vibrate-pattern">
                <DropdownCustom
                  selectVal={vibratePattern}
                  selectOpts={vibratePatternArr}
                  onChange={(e) => onVibratePatternChange(e.target.value)}
                  isDisabled={!enableVibrate || !enableBTScannerTracking }
                />
              </div>
          
              <CheckboxComp >
                <FormControlLabel  style={{ marginLeft: '0' }}
                  control={
                    <Checkbox disabled={!enableBTScannerTracking}
                      onChange={(e) => onLedCheckbox(e.target.checked)}
                      checked={enableLED}
                      name="led"
                  />
                }
                label={t('btScannersNotifications.LED')}
                />
                <QuestionTT arrow title={<>
                  <TTBody>
                    {t('btScannersNotifications.DefaultBlueLED')}
                  </TTBody>
                  </>}>
                  <SVGContainer>
                    <HelpOutlineIcon />
                  </SVGContainer>
                </QuestionTT>
              </CheckboxComp>
            </FormGroup>
            <SectionTitle>{t('btScanners.btDevicerNotifications')}</SectionTitle>
            <FormGroup style={{ marginLeft: '20px' }}>
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={enablePagingBeep}
                    onChange={(e) => onPagingBeepCheckbox(e.target.checked)}
                    name="pagingBeep"

                  />
                }
                label={t('btScanners.beep')}
                
              />
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={enablePagingLED}
                    onChange={(e) => onPagingLedCheckbox(e.target.checked)}
                    name="pagingLED"

                    // value={setEnableAudio}
                  />
                }
                label={t('btScanners.led')}
                
              />              
            </FormGroup>
            
            <SectionTitle>{t('btScanners.automation')}</SectionTitle> 
            <Typography >{t('btScanners.beaconRules')}</Typography>                 
            <FormGroup style={{ marginLeft: '20px' }}>
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={whenDisconnected}
                    onChange={(e) => onWhenDisconnected(e.target.checked)}
                    name="whenDisconnected"

                    // value={setEnableAudio}
                  />
                }
                label={t('btScanners.whenDisconnected')}
                
              />
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={whenUnpaired}
                    onChange={(e) => onWhenUnpaired(e.target.checked)}
                    name="whenUnpaired"

                    // value={setEnableAudio}
                  />
                }
                label={t('btScanners.whenUnpaired')}
                
              />
              <FormControlLabel
                control={
                  <Checkbox disabled={!enableBTScannerTracking}
                    checked={whenUltraLowPower}
                    onChange={(e) => onWhenUltraLowPower(e.target.checked)}
                    name="whenUltraLowPower"

                    // value={setEnableAudio}
                  />
                }
                label={t('btScanners.whenUltraLowPower')}
                
              />              
            </FormGroup>

            <ButtonContainer style={{}}>
              <Button
                onClick={() => onClickResetBtn()}
                type="secondary"
                style={{ backgroundColor: '#757575', margin: '8px' }}
              >
                {t('lostDeviceNearbyNotifications.Reset to default')}
              </Button>
            </ButtonContainer>
            {anyOneChanged &&
              <ButtonContainer>
                <Button
                  onClick={() => onClickCancelBtn()}
                  type="primary"
                  style={{ background: 'white', color: 'black', border: '2px solid gray' }}
                >
                  {t('cancel')}
                </Button>
                <Button
                  onClick={handleSaveChanges}
                  type="primary"
                  style={{}}
                >
                  {t('save')}
                </Button>
              </ButtonContainer>
            }

        </div>
        <BottomNavLinks />
    </StyledContentWrapper>
    <Snackbar
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={() => setSnackbarOpen(false)}
            >
                <SnackbarContent error={serverResponse.current.status ? false : true}>
                    {serverResponse.current.msg}
                </SnackbarContent>
            </Snackbar>    
    </>
  );
}